import BaseService from './BaseService';
import { Observable } from "rxjs";
import { CBlocker } from '@/components/Blocker/CBlocker';
export default class EventService {
    constructor() {
        this.path = 'events';
    }
    getOverlapped(from, to) {
        let content = Object();
        content.from = from;
        content.to = to;
        return BaseService.get(this.path + '/overlapped', content);
    }
    openLocalizations(date) {
        let content = Object();
        content.date = date;
        return BaseService.get(this.path + '/openLocalizations', content);
    }
    getAll(filter, order, page, length) {
        let content = Object();
        if (filter) {
            content.filter = filter;
        }
        if (order) {
            content.order = order;
        }
        if (page) {
            content.page = page;
        }
        if (length) {
            content.length = length;
        }
        return BaseService.get(this.path, content);
    }
    get(id) {
        return BaseService.get(this.path + '/' + id);
    }
    add(reg) {
        CBlocker.showLoading();
        const content = reg.toNormalize();
        return new Observable((observer) => {
            BaseService.post(this.path, content, undefined, false).subscribe((success) => {
                observer.next(success);
                CBlocker.showSuccess('Evento creado');
            }, (error) => {
                observer.error(error);
                CBlocker.showError(error.message);
            });
        });
    }
    addAll(regs, start_ts) {
        CBlocker.showLoading();
        const content = {
            start_ts: start_ts,
            events: regs.map((item) => item.toNormalize())
        };
        return new Observable((observer) => {
            BaseService.post(this.path + '/set', content, undefined, false).subscribe((success) => {
                observer.next(success);
                CBlocker.hide();
            }, (error) => {
                observer.error(error);
                CBlocker.showError(error.message);
            });
        });
    }
    update(reg) {
        CBlocker.showLoading();
        let content = Object.assign({}, reg);
        delete (content.id);
        return new Observable((observer) => {
            BaseService.put(this.path + '/' + reg.id, content, undefined, false).subscribe((success) => {
                observer.next(success);
                CBlocker.showSuccess('¡Actualizado!');
            }, (error) => {
                observer.error(error);
                CBlocker.showError(error.message);
            });
        });
    }
    delete(reg) {
        CBlocker.showLoading();
        return new Observable((observer) => {
            BaseService.delete(this.path + '/' + reg.id, undefined, false).subscribe((success) => {
                observer.next(success);
                CBlocker.showSuccess('Evento eliminado');
            }, (error) => {
                observer.error(error);
                CBlocker.showError(error.message);
            });
        });
    }
    getEnums() {
        if (EventService.enums.length == 0) {
            return BaseService.get(this.path + '/enums');
        }
        else {
            return new Observable((observer) => {
                observer.next(EventService.enums);
            });
        }
    }
}
EventService.enums = new Array();
